/* Style Mobo — Scroll to top with circular progress ring */
(function () {
  const CIRCUMFERENCE = 2 * Math.PI * 19; // r=19 → ~119.4

  const btn = document.createElement('button');
  btn.id = 'sm-scroll-top';
  btn.setAttribute('aria-label', 'Scroll to top');
  btn.innerHTML = `
    <svg class="sm-scroll-top__ring" viewBox="0 0 44 44" aria-hidden="true">
      <circle class="sm-scroll-top__track" cx="22" cy="22" r="19" fill="none" stroke-width="2.5"/>
      <circle class="sm-scroll-top__fill" cx="22" cy="22" r="19" fill="none" stroke-width="2.5"
        stroke-dasharray="${CIRCUMFERENCE}" stroke-dashoffset="${CIRCUMFERENCE}" stroke-linecap="round"
        transform="rotate(-90 22 22)"/>
    </svg>
    <svg class="sm-scroll-top__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polyline points="18 15 12 9 6 15"/>
    </svg>`;
  document.body.appendChild(btn);

  const fill = btn.querySelector('.sm-scroll-top__fill');

  function update() {
    const scrollTop = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const pct = maxScroll > 0 ? Math.min(scrollTop / maxScroll, 1) : 0;

    btn.classList.toggle('is-visible', scrollTop > 200);
    fill.style.strokeDashoffset = CIRCUMFERENCE * (1 - pct);
  }

  window.addEventListener('scroll', update, { passive: true });
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  update();
})();
